function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const api = buildService('/elsters/{id}/further_requirement', {
  only: ['all', 'update']
});
const uploadDocumentsApi = buildService('/further_requirements/{id}/further_requirement_documents', {
  only: ['delete']
}, {
  only: ['postFormData']
});
const furtherRequirementService = {
  useFetchFurtherRequirement: function (elsterId, setLoading) {
    let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (elsterId == null) {
          return null;
        }
        const response = await api.all(elsterId);
        return response;
      }, [elsterId]),
      setLoading,
      fetchImmediately,
      initialStateValue: null
    });
  },
  useUpdateFurtherRequirement: (elsterId, setLoading, setFurtherRequirement) => {
    const updateFurtherRequirement = serviceMethods.useUpdate({
      callback: useCallback(async payload => {
        const response = await api.update(elsterId, '', payload);
        setFurtherRequirement(prev => _objectSpread(_objectSpread({}, prev), response));
        return response;
      }, [elsterId, setFurtherRequirement]),
      setLoading
    });
    return [updateFurtherRequirement];
  },
  useUploadDocuments: (furtherRequirementId, setLoading, setFurtherRequirement) => {
    const uploadDocuments = serviceMethods.usePostFormData({
      callback: useCallback(async _ref => {
        let {
          formData
        } = _ref;
        if (furtherRequirementId == null) {
          return null;
        }
        const response = await uploadDocumentsApi.postFormData(furtherRequirementId, formData);
        setFurtherRequirement(prev => {
          const existing = prev.further_requirement_documents;
          return _objectSpread(_objectSpread({}, prev), {}, {
            further_requirement_documents: [...existing, response]
          });
        });
        return response;
      }, [furtherRequirementId, setFurtherRequirement]),
      setLoading
    });
    return [uploadDocuments];
  },
  useDeleteDocuments: (furtherRequirementId, setLoading, setFurtherRequirement) => {
    const {
      t
    } = useTranslation();
    const deleteDocuments = serviceMethods.useDelete({
      callback: useCallback(async _ref2 => {
        let {
          furtherRequirementDocumentId
        } = _ref2;
        if (window.confirm(t(window.MARKET_CONSTANTS.DELETE_FILE_CONFIRMATION_MESSAGE))) {
          await uploadDocumentsApi.delete(furtherRequirementId, furtherRequirementDocumentId);
          setFurtherRequirement(prev => {
            const existing = prev.further_requirement_documents;
            return _objectSpread(_objectSpread({}, prev), {}, {
              further_requirement_documents: existing.filter(d => d.id !== furtherRequirementDocumentId)
            });
          });
        }
      }, [furtherRequirementId, setFurtherRequirement]),
      setLoading
    });
    return [deleteDocuments];
  }
};
furtherRequirementService.useCrud = function (elsterId, setLoading) {
  let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const [furtherRequirement, setFurtherRequirement, fetchFurtherRequirement] = furtherRequirementService.useFetchFurtherRequirement(elsterId, setLoading, fetchImmediately);
  const [updateFurtherRequirement] = furtherRequirementService.useUpdateFurtherRequirement(elsterId, setLoading, setFurtherRequirement);
  const [uploadDocuments] = furtherRequirementService.useUploadDocuments(furtherRequirement === null || furtherRequirement === void 0 ? void 0 : furtherRequirement.id, setLoading, setFurtherRequirement);
  const [deleteDocuments] = furtherRequirementService.useDeleteDocuments(furtherRequirement === null || furtherRequirement === void 0 ? void 0 : furtherRequirement.id, setLoading, setFurtherRequirement);
  return {
    furtherRequirement,
    setFurtherRequirement,
    fetchFurtherRequirement,
    updateFurtherRequirement,
    uploadDocuments,
    deleteDocuments
  };
};
export default furtherRequirementService;